import React from "react";
import { Dashboard, DeviceManagement, Apps } from "../../SuperAdmin";
/* SVG Icons */
import { ReactComponent as dashboardIcon } from "../../../assets/appIcons/sidebar-icons/dashboard.svg?react";
import { ReactComponent as VendingMachineIcon } from "../../../assets/appIcons/sidebar-icons/vending-machines.svg?react";
import { ReactComponent as ProductIcon } from "../../../assets/appIcons/sidebar-icons/products.svg?react";
import { ReactComponent as apps } from "../../../assets/appIcons/sidebar-icons/apps.svg?react";
// import { ReactComponent as AppStoreIcon } from "../../../assets/appIcons/sidebar-icons/appstore.svg?react";
import { ReactComponent as AdvertisingIcon } from "../../../assets/appIcons/sidebar-icons/advertising.svg?react";
import { ReactComponent as EventIcon } from "../../../assets/appIcons/sidebar-icons/event.svg?react";
import { ReactComponent as FinanceIcon } from "../../../assets/appIcons/sidebar-icons/finance.svg?react";
import { ReactComponent as HealthIcon } from "../../../assets/appIcons/sidebar-icons/health.svg?react";
// import { ReactComponent as NurseIcon } from "../../../assets/appIcons/sidebar-icons/nurse.svg?react";
import { ReactComponent as InventoryIcon } from "../../../assets/appIcons/sidebar-icons/inventory-forecast.svg?react";
import { ReactComponent as InventoryAnaIcon } from "../../../assets/appIcons/sidebar-icons/dashboard.svg?react";
import { ReactComponent as LocationAnaIcon } from "../../../assets/appIcons/sidebar-icons/locations.svg?react";
import { ReactComponent as PlanogramIcon } from "../../../assets/appIcons/sidebar-icons/Planogram.svg?react";
import { ReactComponent as ThemeIcon } from "../../../assets/appIcons/sidebar-icons/theme.svg?react";

export const upperRoutes = [
  {
    label: "Dashboard",
    sidebar_icon: dashboardIcon,
    path: "/dashboard",
    key: "sa_dashbaord",
    onlySA: false,
    component: Dashboard,
    visible: true,
  },
  {
    label: "Vending Machines",
    sidebar_icon: VendingMachineIcon,
    path: "/vending-machines",
    key: "sa_vending_machines",
    component: DeviceManagement,
    visible: true,
  },
];

export const downRoutes = [
  // {
  //     label: 'App Store',
  //     sidebar_icon: AppStoreIcon,
  //     path: '/appstore',
  //     key: 'sa_apps_manager',
  //     component: AppStore,
  //     visible: true,
  // },
  {
    label: "Apps",
    sidebar_icon: apps,
    path: "/apps",
    key: "sa_apps",
    component: Apps,
    visible: true,
  },
];

export const FE_ICONS = {
  product: {
    renderIcon: (props) => <ProductIcon {...props} />,
  },
  advertising: {
    renderIcon: (props) => <AdvertisingIcon {...props} />,
  },
  "event-logs": {
    renderIcon: (props) => <EventIcon {...props} />,
  },
  finance: {
    renderIcon: (props) => <FinanceIcon {...props} />,
  },
  "health-&-monitoring": {
    renderIcon: (props) => <HealthIcon {...props} />,
  },
  // "huddle-nurse": {
  //   renderIcon: (props) => <NurseIcon {...props} />,
  // },
  inventory: {
    renderIcon: (props) => <InventoryIcon {...props} />,
  },
  "inventory-analytics": {
    renderIcon: (props) => <InventoryAnaIcon {...props} />,
  },
  location: {
    renderIcon: (props) => <LocationAnaIcon {...props} />,
  },
  planogram: {
    renderIcon: (props) => <PlanogramIcon {...props} />,
  },
  "theme-manager": {
    renderIcon: (props) => <ThemeIcon {...props} />,
  },
};
